
export const getDateInHoursAndMinutes = (date?: Date | string) => {
    if (!date) return date;

    return new Date(date).toLocaleTimeString('nl-NL', {
        hour: '2-digit',
        minute: '2-digit'
    })
}

export const getDateForRegistrationClosed = (date?: Date | string | null) => {
    if (!date) return date;

    return new Date(date).toLocaleDateString('nl-NL', {
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    })
}